import { render } from "./Assets.vue?vue&type=template&id=e5c9fa40"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=e5c9fa40&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__